import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import moment from "moment";

export default {
  methods: {
    formatDate: function (value) {
      let auxDate = moment(value, "YYYY-MM-DDTHH:mm:ss.SSSZ");
      if (auxDate.isValid()){
        return auxDate.format("DD/MM/YYYY");
      }
      else return undefined;
    },
    formatDateHour: function (value) {
      let auxDate = moment(value, "YYYY-MM-DDTHH:mm:ss.SSSZ");
      if (auxDate.isValid()) return auxDate.format("DD/MM/YYYY HH:mm");
      else return undefined;
    },
    trunkString: function(value, length) {
      if (value.length > length-2) {
        value = value.substr(0, length-3);
        var points = "...";
        value = value.concat(points);
      } else {
        value.substr(0, length);
      }
      return value;
    },
    trunkStringWithoutPoints: function(value, length) {
      if (value.length > length-2) {
        value = value.substr(0, length-3);
      } else {
        value.substr(0, length);
      }
      return value;
    },
    dateToDbFormat: date => moment(date).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
  },
};